import Export1CRequest from "../../libs/core-api-requests/service/export1CRequest";
import { IExport1CDto, IExport1CViewDto } from "../../libs/coreapi-dto/service/export1C";
import CoreApiService from "../../system/api/coreApiService";
import { ServiceDataProvider } from "./Common";


export class Export1CDataProvider extends ServiceDataProvider<IExport1CViewDto, IExport1CDto> {

    private _coreApiService: CoreApiService

    constructor(coreApiService: CoreApiService) {
        super();
        this._coreApiService = coreApiService
    }

    getDataRequest(): Promise<Export1CRequest> {
        return this._coreApiService.export1CRequest
    }

    getData(callback?: (data: IExport1CViewDto) => void) {
        this.getDataRequest().then((r) =>
            r.getData((e) => {
                if (e.respType === "isCompleted") {
                    callback?.(e.data);
                } else {
                    throw new Error(e.message.title);
                }
            })
        );
    }

    export(body: IExport1CViewDto, callback?: (e) => void) {
        this.getDataRequest().then((r) =>
            r.export(body, (e) => {
                if (e.respType === "isCompleted") {
                    callback?.(e.data);
                } else {
                    throw new Error(e.message.title);
                }
            })
        );
    }

    exportOperations(callback?: (data) => void) {
        this.getDataRequest().then((r) =>
            r.exportOperations((e) => {
                if (e.respType === "isCompleted") {
                    callback?.(e.data);
                } else {
                    throw new Error(e.message.title);
                }
            })
        );
    }
    
    exportContractors(callback?: (data) => void) {
        this.getDataRequest().then((r) =>
            r.exportContractors((e) => {
                if (e.respType === "isCompleted") {
                    callback?.(e.data);
                } else {
                    throw new Error(e.message.title);
                }
            })
        );
    }

    exportStores(callback?: (data) => void) {
        this.getDataRequest().then((r) =>
            r.exportStores((e) => {
                if (e.respType === "isCompleted") {
                    callback?.(e.data);
                } else {
                    throw new Error(e.message.title);
                }
            })
        );
    }
}